module.exports = __webpack_public_path__ + "img/ipo.ee8c508d.jpg";